export declare type TicketType = 'NON_SI' | 'SI';

const getTicketTypeFromSi = (si: boolean | number): TicketType => {
  return si ? 'SI' : ('NON_SI' as TicketType);
};

const getSiFromTicketType = (ticketType: TicketType): boolean => {
  if (!allTicketTypes.includes(ticketType))
    throw Error(`invalid ticketType ${ticketType}`);
  return ticketType === 'SI';
};

const allTicketTypes = ['NON_SI', 'SI'];
const TicketTypeHelper = {
  getTicketTypeFromSi,
  allTicketTypes,
  getSiFromTicketType,
};

export default TicketTypeHelper;
